/* eslint no-nested-ternary: 0 */
/* eslint no-extra-boolean-cast: 0 */

angular.module('directives').directive('serviceScroll', ['$parse', '$window',
    ($parse, $window) => ({
        template:
            '<div><div class="ngsb-wrap">' +
            '<div class="ngsb-container" ng-transclude></div>' +
            '<div class="ngsb-scrollbar" style="position: absolute; display: block;"' +
            'ng-show="showYScrollbar"><div class="ngsb-thumb-container">' +
            '<div class="ngsb-thumb-pos" oncontextmenu="return false;">' +
            '<div class="ngsb-thumb" ></div></div><div class="ngsb-track"></div>' +
            '</div></div></div></div>',
        restrict: 'A',
        transclude: true,
        replace: true,

        link: (scope, element, attrs) => {

            let mainElm;
            let transculdedContainer;
            let tools;
            let thumb;
            let thumbLine;
            let track;
            const flags = { bottom: Object.prototype.hasOwnProperty.call(attrs, 'bottom') };
            const win = angular.element($window);
            const dragger = { top: 0 };
            const page = { top: 0 };
            let scrollboxStyle;
            let draggerStyle;
            let draggerLineStyle;
            let pageStyle;
            const calcStyles = () => {

                scrollboxStyle = {
                    position: 'relative',
                    overflow: 'hidden',
                    'max-width': '100%',
                    height: '100%',
                };
                if (page.height) {

                    scrollboxStyle.height = `${page.height}px`;

                }
                draggerStyle = {
                    position: 'absolute',
                    height: `${dragger.height}px`,
                    top: `${dragger.top}px`,
                };
                draggerLineStyle = {
                    position: 'relative',
                    'line-height': `${dragger.height}px`,
                };
                pageStyle = {
                    position: 'relative',
                    top: `${0}px`,
                    overflow: 'hidden',
                };

            };

            const redraw = () => {

                const draggerOffset = dragger.top / page.height;
                thumb.css('top', `${dragger.top}px`);
                page.top = -Math.round(page.scrollHeight * draggerOffset);
                angular.element(transculdedContainer.children()[1]).css('top', `${page.top}px`);

            };
            const trackClick = (event) => {

                const offsetY = Object.prototype.hasOwnProperty.call(event, 'offsetY') ? event.offsetY : event.layerY;
                const newTop = Math.max(0, Math.min(parseInt(dragger.trackHeight, 10) -
                        parseInt(dragger.height, 10), offsetY));
                dragger.top = newTop;
                redraw();
                event.stopPropagation();

            };
            const wheelHandler = (event) => {

                const wheelDivider = 20;
                const deltaY = event.wheelDeltaY !== undefined ?
                    event.wheelDeltaY / wheelDivider : event.wheelDelta !== undefined ?
                        event.wheelDelta / wheelDivider : -event.detail * (wheelDivider / 10);

                dragger.top = Math.max(0, Math.min(parseInt(page.height, 10) -
                        parseInt(dragger.height, 10), parseInt(dragger.top, 10) - deltaY));
                redraw();
                if (!!event.preventDefault) {

                    event.preventDefault();

                }

            };
            let lastOffsetY;
            const thumbDrag = (event, offsetX, offsetY) => {

                dragger.top = Math.max(0, Math.min(parseInt(dragger.trackHeight, 10) -
                        parseInt(dragger.height, 10), offsetY));
                event.stopPropagation();

            };
            const dragHandler = (event) => {

                const newOffsetY = event.pageY - thumb[0].scrollTop - lastOffsetY;
                const newOffsetX = 0;
                thumbDrag(event, newOffsetX, newOffsetY);
                redraw();

            };

            const buildScrollbar = (rollToBottom) => {

                const wheelEvent = win[0].onmousewheel !== undefined ?
                    'mousewheel' : 'DOMMouseScroll';

                rollToBottom = flags.bottom || rollToBottom;
                mainElm = angular.element(element.children()[0]);
                transculdedContainer = angular.element(mainElm.children()[0]);
                tools = angular.element(mainElm.children()[1]);
                thumb = angular.element(angular.element(tools.children()[0]).children()[0]);
                thumbLine = angular.element(thumb.children()[0]);
                track = angular.element(angular.element(tools.children()[0]).children()[1]);
                page.height = element[0].offsetHeight;
                page.scrollHeight = transculdedContainer[0].offsetHeight;

                if (page.height < page.scrollHeight) {

                    scope.showYScrollbar = true;
                    dragger.height =
                            Math.round((page.height / page.scrollHeight) * page.height);
                    dragger.trackHeight = page.height;
                    calcStyles();
                    element.css({ overflow: 'hidden' });
                    mainElm.css(scrollboxStyle);
                    transculdedContainer.css(pageStyle);
                    thumb.css(draggerStyle);
                    thumbLine.css(draggerLineStyle);
                    track.bind('click', trackClick);
                    transculdedContainer[0].addEventListener(wheelEvent, wheelHandler, false);
                    thumb.on('mousedown', (event) => {

                        lastOffsetY = event.pageY - thumb[0].offsetTop;
                        win.on('mouseup', () => {

                            win.off('mousemove', dragHandler);
                            event.stopPropagation();

                        });
                        win.on('mousemove', dragHandler);
                        event.preventDefault();

                    });
                    if (rollToBottom) {

                        flags.bottom = false;
                        dragger.top = parseInt(page.height, 10) - parseInt(dragger.height, 10);

                    } else {

                        dragger.top = Math.max(0, Math.min(parseInt(page.height, 10) -
                                parseInt(dragger.height, 10), parseInt(dragger.top, 10)));

                    }
                    redraw();

                } else {

                    scope.showYScrollbar = false;
                    thumb.off('mousedown');
                    transculdedContainer[0].removeEventListener(
                        wheelEvent,
                        wheelHandler,
                        false,
                    );
                    transculdedContainer.attr('style', 'position:relative;top:0');
                    mainElm.css({ height: '100%' });

                }

            };

            let rebuildTimer;
            const rebuild = (e, data) => {

                const rollToBottom = !!data && !!data.rollToBottom;
                if (rebuildTimer !== null) {

                    clearTimeout(rebuildTimer);

                }

                rebuildTimer = setTimeout(() => {

                    page.height = null;
                    buildScrollbar(rollToBottom);
                    if (!scope.$$phase) {

                        scope.$digest();

                    }

                }, 72);

            };

                // load scrollbar on window ready
            scope.$watch(() => {

                if (!angular.element(document).find('html').hasClass('ie8')) {

                    buildScrollbar();

                }

            });

            if (!!attrs.rebuildOn) {

                attrs.rebuildOn.split(' ').forEach((eventName) => {

                    scope.$on(eventName, rebuild);

                });

            }
            if (Object.prototype.hasOwnProperty.call(attrs, 'rebuildOnResize')) {

                win.on('resize', rebuild);

            }

        },
    })]);



// WEBPACK FOOTER //
// ./scripts/directives/service-scroll.js